// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-description-block{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color:black ;
}


.service-description-title{
    font-size: 24px;
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: auto;
}


.service-description-tagline{
    color: white;
    text-align: center;
    display: flex;
    font-weight: lighter;
    align-items: center;
    justify-content: center;
    width: 60%;
    margin: auto;
    font-weight: 100;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 19.5px;
    margin-block-end: 13px;
    margin-block-start: 0px;
    margin-bottom: 13px;
    line-height: 1.4em;
}

.service-desc-cards-container{
    width: 100%;
    margin: auto;
    padding: 20px;
}

.card-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 30px;
  }

  .service-card-title-container{
    width: 52%;
    color: white;
  }

  .text-info{
    font-size: 18px;
    font-weight: lighter;
    line-height: 1.4em;
  }

  .service-card-title{
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 18px;
  }

  @media screen and (max-width: 600px) {
    .card-container {
      display: block;
      width: 100%;
    }
    .service-card-title-container{
        width: 100%;
    }
    .service-desc-cards-container{
      width: 90%;
      margin: auto;
      font-size: 10px;
    }
    .service-card-title{
        margin-top: 10px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .service-description-tagline{
        width: 100%;
    }


  }

 `, "",{"version":3,"sources":["webpack://./src/components/ServiceComponents/ServiceDescriptions/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;MACE,cAAc;MACd,WAAW;IACb;IACA;QACI,WAAW;IACf;IACA;MACE,UAAU;MACV,YAAY;MACZ,eAAe;IACjB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;;;EAGF","sourcesContent":[".service-description-block{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color:black ;\n}\n\n\n.service-description-title{\n    font-size: 24px;\n    color: white;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin: auto;\n}\n\n\n.service-description-tagline{\n    color: white;\n    text-align: center;\n    display: flex;\n    font-weight: lighter;\n    align-items: center;\n    justify-content: center;\n    width: 60%;\n    margin: auto;\n    font-weight: 100;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 19.5px;\n    margin-block-end: 13px;\n    margin-block-start: 0px;\n    margin-bottom: 13px;\n    line-height: 1.4em;\n}\n\n.service-desc-cards-container{\n    width: 100%;\n    margin: auto;\n    padding: 20px;\n}\n\n.card-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 30px;\n  }\n\n  .service-card-title-container{\n    width: 52%;\n    color: white;\n  }\n\n  .text-info{\n    font-size: 18px;\n    font-weight: lighter;\n    line-height: 1.4em;\n  }\n\n  .service-card-title{\n    font-size: 24px;\n    font-weight: 400;\n    margin-bottom: 18px;\n  }\n\n  @media screen and (max-width: 600px) {\n    .card-container {\n      display: block;\n      width: 100%;\n    }\n    .service-card-title-container{\n        width: 100%;\n    }\n    .service-desc-cards-container{\n      width: 90%;\n      margin: auto;\n      font-size: 10px;\n    }\n    .service-card-title{\n        margin-top: 10px;\n        width: 100%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .service-description-tagline{\n        width: 100%;\n    }\n\n\n  }\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
